import styled from 'styled-components';

export const Container = styled.div`
  margin: 16px 0px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-size: 14px;
  line-height: 21px;

  > p {
    margin-bottom: 12px;
  }

  > p:last-of-type {
    margin-bottom: 0px;
  }

  b {
    font-weight: 700;
  }
`;
